import { render, staticRenderFns } from "./BotonProceso.vue?vue&type=template&id=38672dab&"
import script from "./BotonProceso.vue?vue&type=script&lang=js&"
export * from "./BotonProceso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports